<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Reports in Progress</h1>

                        <button v-if="isAdmin" class="btn btn-primary mr-2" @click="getAdminGLReport()" :disabled="loading">GL Report</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <b-spinner class="center-spinner" v-if="!loaded" variant="primary" label="Spinning"></b-spinner>
                        <b-table v-if="loaded" striped hover :items="response" show-empty="true" empty-text='There are no records to show'
                                 :fields="['ReportName','Type','Status','ReimbursementTotal','Action','CreatedBy']">
                            <template v-slot:cell(ReportName)="data">
                                <span v-html="data.value"></span>
                            </template>
                            <template v-slot:cell(SubmittedDate)="data">
                                {{data.value | formatDate}}
                            </template>
                            <template v-slot:cell(ReimbursementTotal)="data">
                                {{data.value | currency}}
                            </template>
                            <template v-slot:cell(Action)="data">
                                <div v-if="data.item.StatusId == 1 || data.item.StatusId == 5 || data.item.StatusId == 6">
                                    <font-awesome-icon class="icons cursor-pointer" icon="trash" @click="deleteExpenseReport(data.item.ExpenseReportId)" />
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReportService from '@/services/ReportService';
    import UserService from '@/services/UserService';
    import moment from 'moment';

    export default {
        async created() {
            // moved to watch
        },
        data() {
            return {
                response: null,
                loaded: false,
                isAdmin: false
            }
        },
        watch: {
            'msal.accessToken': {
                async handler(value) {
                    console.log('getting user roles')
                    this.isAdmin = await UserService.isUserAdmin();

                    if (this.isAdmin) {
                        this.response = await ReportService.getReportsInProgress(this.$route.params.admin);
                    } else {
                        this.response = await ReportService.getReportsInProgress(false);
                    }
                    this.loaded = true;
                },
                immediate: true
            }
        },
        methods: {
            async deleteExpenseReport(erID) {
                if (confirm('Are you sure you want to delete this expense report?')) {
                    try {
                        await ReportService.deleteExpenseReport(erID);
                        this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Expense Report deleted." });
                        if (this.isAdmin) {
                            this.response = await ReportService.getReportsInProgress(this.$route.params.admin);
                        } else {
                            this.response = await ReportService.getReportsInProgress(false);
                        }
                    } catch (e) {
                        this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                    }
                }
            },
            getAdminGLReport() {
                this.submitted = true;
                this.loading = true;

                this.$http
                    .get(`ExpenseReports/Report/Status/GL`, {
                        params: {
                            status: [1, 5, 6]
                        },
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        var anchorTag = document.createElement("a");
                        anchorTag.style = "display: none;";
                        document.body.appendChild(anchorTag);

                        const downloadUrl = window.URL.createObjectURL(file);
                        anchorTag.href = downloadUrl;
                        anchorTag.download = 'GLReport_' + moment().format('MM_DD_YYYY_hh_mm_ss') + '.csv';
                        anchorTag.click();
                        setTimeout(() => {
                            window.URL.revokeObjectURL(downloadUrl);
                        }, 100);
                        this.submitted = false;
                    })
                    .catch((error, reason) => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: "An error occurred generating the GL Report."
                        });
                    })
                    .finally(() => this.loading = false)
            }
        }
    }
</script>